import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=38f21d87&scoped=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f21d87",
  null
  
)

export default component.exports